<template>
<div>
  <div v-if="!user.loggedIn">
    <fieldset class="border-bottom form-group mb-4">
      <legend><h2>Register a new Account with EZSalt</h2></legend>
    </fieldset>

    <div v-if="error" class="alert alert-danger">{{ error }}</div>

    <div>
      <div class="form-group">
        <label for="first_name">Your Name</label>
        <div class="input-group">
          <input v-model="$store.state.new_user_data.first_name" type="text" class="form-control" id="first_name" placeholder="First Name">
          <span class="input-group-addon"></span>
          <input v-model="$store.state.new_user_data.last_name" type="text" class="form-control" id="last_name" placeholder="Last Name">
        </div>
      </div>
      <div class="form-group">
        <label for="inputEmail1">Email address</label>
        <input v-model="form.email" type="email" class="form-control" id="inputEmail1" aria-describedby="emailHelp" placeholder="Enter email">
      </div>
      <div class="form-group">
        <label for="inputPassword1">Password</label>
        <input v-model="form.password" type="password" class="form-control" id="inputPassword1" placeholder="Password">
      </div>
      <div class="m-5">
        <button @click="register" type="submit" class="btn btn-primary btn-outline-white m-1 col-5">Register</button>
        <br>
        <br>
        <router-link :to="{ name: 'login' }"><small>Already have an Account</small></router-link>
      </div>
      <button class="btn" @click="google">
        <!-- Dark and Light Modes -->
        <img alt=" Sign in with Google" src="../assets/google_signin_buttons/web/1x/btn_google_signin_dark_pressed_web.png"/>
        <!-- <img src="../assets/google_signin_buttons/web/1x/btn_google_signin_light_normal_web.png"/> -->
      </button>
    </div>

  </div>
  <div v-else>
    <dashboard/>
  </div>
</div>
</template>

<script>
import dbservice from '../services/dbservice.js';
import { mapGetters } from 'vuex'
import Dashboard from '../pages/Dashboard'

export default {
  name: "Register",
  components: {
    Dashboard
  },
  data: () => ({
    form: {
      email: "",
      password: ""
    },
    error: null,
  }),
  methods: {

    register() {
      dbservice.submitRegister(this.form)
      .catch(err => this.error = err.message)
    },
    google() {
      dbservice.signInWithGoogle()
      .catch(err => this.error = err.message)
    }

  },
  computed: {
    ...mapGetters({
      user: "user"
    })
  }
};
</script>